export const APP_API_BASE = process.env.VUE_APP_API_URL || 'https://admin.elemsy.io'
export const APP_API_URL = `${APP_API_BASE}/api`

export const SOCKET_HOST = process.env.VUE_APP_SOCKET_HOST;

export const PUSHER_APP_ID = process.env.VUE_APP_PUSHER_APP_ID;
export const PUSHER_APP_KEY = process.env.VUE_APP_PUSHER_APP_KEY;
export const PUSHER_APP_SECRET = process.env.VUE_APP_PUSHER_APP_SECRET;
export const PUSHER_HOST = process.env.VUE_APP_PUSHER_HOST;
export const PUSHER_PUBLIC_HOST = process.env.VUE_APP_PUSHER_PUBLIC_HOST;
export const PUSHER_PORT = process.env.VUE_APP_PUSHER_PORT;
export const PUSHER_PUBLIC_PORT = process.env.VUE_APP_PUSHER_PUBLIC_PORT;
export const PUSHER_SCHEME = process.env.VUE_APP_PUSHER_SCHEME;
export const PUSHER_APP_CLUSTER = process.env.VUE_APP_PUSHER_APP_CLUSTER;

export const ZOOM_SDK_ID = process.env.VUE_APP_ZOOM_SDK_KEY
export const ZOOM_SDK_SECRET = process.env.VUE_APP_ZOOM_SDK_SECRET
